/* istanbul ignore file */

/* tslint:disable */

/* eslint-disable */
export var LandingPageThemeEnum;

(function (LandingPageThemeEnum) {
  LandingPageThemeEnum["GOODS_IN_TRANSIT"] = "goods-in-transit";
  LandingPageThemeEnum["CONTRACTOR_SME"] = "contractor_sme";
  LandingPageThemeEnum["COMMERCIAL_BUSINESS"] = "commercial_business";
  LandingPageThemeEnum["RECRUITMENT_PAYROLL"] = "recruitment_payroll";
})(LandingPageThemeEnum || (LandingPageThemeEnum = {}));